// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import errorMixin from '@/mixins/errorMixin'
import mainMixin from '@/mixins/mainMixin'
import 'babel-polyfill'
import VeeValidate from 'vee-validate'
import Vue from 'vue'
import VueCarousel from 'vue-carousel'
import VueClipboard from 'vue-clipboard2'
import Tooltip from 'vue-directive-tooltip'
import FBSignInButton from 'vue-facebook-signin-button'
import VueFlashMessage from 'vue-flash-message'
import moment from 'vue-moment'
import VueTruncate from 'vue-truncate-filter'
import App from './App'
import router from './router'

require('vue-flash-message/dist/vue-flash-message.min.css')

import FlagIcon from 'vue-flag-icon'
import linkify from 'vue-linkify'
import './filters'

import MainLayout from '@/components/layouts/Main'
import VueCountdown from '@chenfengyuan/vue-countdown'
import VueParticles from 'vue-particles'
import { SimpleSVG } from 'vue-simple-svg'
import VueSweetalert2 from 'vue-sweetalert2'
import Vuebar from 'vuebar'
import Vuetify from 'vuetify'
import { store } from './store/store'

import i18n from './lang/lang'

import config from '@/app-config'

import th from 'vee-validate/dist/locale/th'

import { Validator } from 'vee-validate'
import VueKonva from 'vue-konva'
import Paginate from 'vuejs-paginate'
import 'vuetify/dist/vuetify.min.css'

Vue.use(VueKonva)

Vue.component('paginate', Paginate)

const SweetalertoOptions = {
  confirmButtonColor: '#61a9de',
  cancelButtonColor: '#ff7674'
}
Vue.use(VueSweetalert2, SweetalertoOptions)

Vue.use(Vuebar)
Vue.use(Vuetify, {
  theme: {
    primary: config.theme.brand_color
  }
})

Vue.use(VueParticles)
Vue.use(VueFlashMessage)
Vue.use(Tooltip)
Vue.use(VueClipboard)
Vue.use(VeeValidate, { locale: 'th' })
Validator.localize({ th: th })
Vue.use(VueCarousel)
Vue.use(FBSignInButton)
Vue.use(VueTruncate)
Vue.use(moment)
Vue.use(FlagIcon)

Vue.component('main-layout', MainLayout)
Vue.component(VueCountdown.name, VueCountdown)
Vue.component('vue-simple-svg', SimpleSVG)

Vue.directive('linkified', linkify)

Vue.config.productionTip = false

Validator.extend(
  'isLessThanOrEqual',
  (value, [otherValue]) => {
    return parseFloat(value) <= parseFloat(otherValue)
  },
  {
    hasTarget: true
  }
)

Validator.extend('isUrl', value => {
  var pattern = new RegExp(
    /^(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
  ) // fragment locator
  return pattern.test(value)
})

Validator.extend('isPhone', value => {
  var pattern = new RegExp(/^[+]?[0-9]{3,12}$/gim)
  return pattern.test(value)
})

Vue.mixin(mainMixin)
Vue.mixin(errorMixin)

/* eslint-disable no-new */
export const app = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js